(function () {
  if (window.HaloFulfillmentQty && window.HaloFulfillmentQty.__ready) return;

  const PICKUP = 'pickup';
  const DELIVERY = 'delivery';
  const nativeValueSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set;

  function getRoot() {
    return document.querySelector('[data-fulfillment-availability]');
  }

  function quantityInputs() {
    return Array.from(
      document.querySelectorAll(
        '.productView input[name="quantity"], [data-sticky-add-to-cart] input[name="quantity"], form[id^="product-form-sticky-"] input[name="quantity"], quantity-input input[name="quantity"]'
      )
    );
  }

  function getForms() {
    return Array.from(
      document.querySelectorAll(
        '.productView form[data-type="add-to-cart-form"], form[id^="product-form-sticky-"][data-type="add-to-cart-form"]'
      )
    );
  }

  function setInputValue(input, value) {
    const str = String(value);
    if (nativeValueSetter) nativeValueSetter.call(input, str);
    else input.value = str;
    input.defaultValue = str;
    input.setAttribute('value', str);
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function ensureHiddenFields(form, intent, deliveryMin) {
    if (!form) return;

    // Use dedicated selectors — do NOT reuse attrs on quantity inputs.
    let intentInput = form.querySelector('input[type="hidden"][data-jh-fulfillment-prop]');
    if (!intentInput) {
      intentInput = document.createElement('input');
      intentInput.type = 'hidden';
      intentInput.name = 'properties[Fulfillment]';
      intentInput.setAttribute('data-jh-fulfillment-prop', '');
      form.appendChild(intentInput);
    }
    intentInput.value = intent === PICKUP ? 'Pickup' : 'Delivery';

    let minInput = form.querySelector('input[type="hidden"][data-jh-delivery-min-prop]');
    if (!minInput) {
      minInput = document.createElement('input');
      minInput.type = 'hidden';
      minInput.name = 'properties[_delivery_min]';
      minInput.setAttribute('data-jh-delivery-min-prop', '');
      form.appendChild(minInput);
    }
    minInput.value = String(deliveryMin);
  }

  function deliveryMinFromRoot(root) {
    return Math.max(1, parseInt(root && root.dataset.deliveryMin ? root.dataset.deliveryMin : '1', 10) || 1);
  }

  function pickupMaxFromRoot(root) {
    if (!root || root.dataset.pickupQty === undefined || root.dataset.pickupQty === '') return null;
    const n = parseInt(root.dataset.pickupQty, 10);
    return Number.isFinite(n) && n >= 0 ? n : null;
  }

  function deliveryMaxFromRoot(root) {
    if (!root || root.dataset.deliveryQty === undefined || root.dataset.deliveryQty === '') return null;
    const n = parseInt(root.dataset.deliveryQty, 10);
    return Number.isFinite(n) && n >= 0 ? n : null;
  }

  function qtyForIntent(intent, deliveryMin) {
    return intent === DELIVERY ? Math.max(1, deliveryMin) : 1;
  }

  function maxForIntent(intent, root) {
    if (intent === PICKUP) {
      const pickupMax = pickupMaxFromRoot(root);
      // If we know store qty, hard-cap to it. 0 means unavailable.
      return pickupMax === null ? null : pickupMax;
    }
    const deliveryMax = deliveryMaxFromRoot(root);
    return deliveryMax === null || deliveryMax <= 0 ? null : deliveryMax;
  }

  function setSelected(root, intent) {
    root.querySelectorAll('[data-fulfillment-option]').forEach((btn) => {
      const selected = btn.getAttribute('data-fulfillment-option') === intent && !btn.disabled;
      btn.classList.toggle('is-selected', selected);
      btn.setAttribute('aria-checked', selected ? 'true' : 'false');
    });
    root.dataset.selectedIntent = intent;
  }

  function currentIntent(root) {
    return root.dataset.selectedIntent || root.dataset.defaultIntent || DELIVERY;
  }

  function updateHint(root, intent, deliveryMin, pickupMax) {
    const productView = document.querySelector('.productView');
    if (!productView) return;
    let hint = productView.querySelector('[data-fulfillment-qty-hint]');
    if (!hint) {
      const qtyGroup = productView.querySelector('.productView-quantity, quantity-input');
      if (qtyGroup && qtyGroup.parentNode) {
        hint = document.createElement('p');
        hint.className = 'fulfillment-qty-hint';
        hint.setAttribute('data-fulfillment-qty-hint', '');
        // Place after the quantity block and force a new row (Ella uses floats).
        const anchor = qtyGroup.closest('.quantity_selector') || qtyGroup;
        if (anchor.parentNode) {
          anchor.parentNode.insertBefore(hint, anchor.nextSibling);
        }
      }
    }
    if (!hint) return;
    const text = window.inventory_text || {};
    if (intent === DELIVERY && deliveryMin > 1) {
      hint.textContent = (text.fulfillmentMinimumForDelivery || 'Minimum quantity for delivery: [count]').replace('[count]', String(deliveryMin));
      hint.hidden = false;
    } else if (intent === PICKUP) {
      if (pickupMax != null && pickupMax > 0) {
        hint.textContent = (text.fulfillmentPickupMax || 'Maximum [count] available for store pickup').replace('[count]', String(pickupMax));
      } else {
        hint.textContent = text.fulfillmentNoMinimumForPickup || 'No minimum quantity for store pickup';
      }
      hint.hidden = false;
    } else {
      hint.hidden = true;
    }
  }

  function warnPickupMax(max) {
    const msg = (window.inventory_text && window.inventory_text.fulfillmentPickupMax)
      ? window.inventory_text.fulfillmentPickupMax.replace('[count]', String(max))
      : `Only ${max} available for store pickup`;
    if (typeof halo !== 'undefined' && halo.showWarning) halo.showWarning(msg);
  }

  function applyQuantityForIntent(intent, deliveryMin, root) {
    const min = intent === PICKUP ? 1 : qtyForIntent(intent, deliveryMin);
    const step = intent === PICKUP ? 1 : min;
    const max = maxForIntent(intent, root);
    const inputs = quantityInputs();

    inputs.forEach((input) => {
      const prevIntent = input.getAttribute('data-jh-qty-intent');
      const parsed = parseInt(input.value, 10);
      let nextVal = min;

      if (prevIntent === intent && Number.isFinite(parsed)) {
        nextVal = Math.max(min, parsed);
      }

      if (max != null) {
        input.max = String(max);
        input.setAttribute('data-fulfillment-max', String(max));
        if (max <= 0) {
          nextVal = 0;
        } else if (nextVal > max) {
          nextVal = max;
        }
      } else {
        input.removeAttribute('max');
        input.removeAttribute('data-fulfillment-max');
      }

      input.min = String(min);
      input.step = String(step);
      setInputValue(input, nextVal);
      input.setAttribute('data-jh-qty-intent', intent);
      input.setAttribute('data-fulfillment-min', String(min));
      input.setAttribute('data-fulfillment-step', String(step));
      input.removeAttribute('data-fulfillment-intent');
    });

    return { min, max, count: inputs.length };
  }

  function applyIntent(intent, options) {
    const root = getRoot();
    if (!root) return;

    const storeBtn = root.querySelector('[data-fulfillment-option="pickup"]');
    const deliveryBtn = root.querySelector('[data-fulfillment-option="delivery"]');
    let next = intent || currentIntent(root);
    const opts = options || {};
    const switching = opts.forceDefault || (intent && intent !== currentIntent(root));

    if (next === PICKUP && storeBtn && storeBtn.disabled) next = DELIVERY;
    if (next === DELIVERY && deliveryBtn && deliveryBtn.disabled) next = PICKUP;
    if (next === PICKUP && storeBtn && storeBtn.disabled) return;
    if (next === DELIVERY && deliveryBtn && deliveryBtn.disabled) return;

    const deliveryMin = deliveryMinFromRoot(root);
    const pickupMax = pickupMaxFromRoot(root);
    setSelected(root, next);

    // On explicit switch / boot, reset to the default qty for that option.
    if (switching || opts.resetQty) {
      quantityInputs().forEach((input) => {
        input.removeAttribute('data-jh-qty-intent');
      });
    }

    const result = applyQuantityForIntent(next, deliveryMin, root);
    getForms().forEach((form) => ensureHiddenFields(form, next, deliveryMin));
    updateHint(root, next, deliveryMin, pickupMax);

    if (opts.retryIfEmpty !== false && result.count === 0) {
      setTimeout(() => applyIntent(next, { retryIfEmpty: false, resetQty: opts.resetQty }), 100);
    }
  }

  function clampQuantityInputs() {
    const root = getRoot();
    if (!root) return;
    const intent = currentIntent(root);
    if (intent !== PICKUP) return;
    const max = pickupMaxFromRoot(root);
    if (max == null) return;
    quantityInputs().forEach((input) => {
      const parsed = parseInt(input.value, 10);
      if (!Number.isFinite(parsed)) return;
      if (parsed > max) {
        setInputValue(input, max);
        warnPickupMax(max);
      }
    });
  }

  function onFulfillmentClick(event) {
    const btn = event.target.closest('[data-fulfillment-option]');
    if (!btn || btn.disabled) return;
    const root = btn.closest('[data-fulfillment-availability]') || getRoot();
    if (!root) return;
    event.preventDefault();
    const intent = btn.getAttribute('data-fulfillment-option');
    window.HaloFulfillmentQty._userSelected = true;
    applyIntent(intent, { resetQty: true });
  }

  function findDeliveryMinViolations() {
    const violations = [];
    const seenKeys = new Set();
    document.querySelectorAll('[data-cart-quantity][data-fulfillment]').forEach((input) => {
      const key = input.getAttribute('data-line') || input.getAttribute('data-cart-quantity-id') || input.id;
      if (seenKeys.has(key)) return;
      seenKeys.add(key);
      const fulfillment = String(input.getAttribute('data-fulfillment') || '').toLowerCase();
      const deliveryMin = parseInt(input.getAttribute('data-delivery-min'), 10) || 1;
      const qty = parseInt(input.value, 10) || 0;
      if (fulfillment === 'delivery' && deliveryMin > 1 && qty < deliveryMin) {
        violations.push({ deliveryMin, qty });
      }
    });
    return violations;
  }

  function warnDeliveryMin(violations) {
    if (!violations.length) return false;
    const v = violations[0];
    const msg = (window.inventory_text && window.inventory_text.fulfillmentDeliveryMinNotMet)
      ? window.inventory_text.fulfillmentDeliveryMinNotMet.replace('[count]', String(v.deliveryMin)).replace('[title]', 'one or more items')
      : `Delivery requires a minimum of ${v.deliveryMin}`;
    if (typeof halo !== 'undefined' && halo.showWarning) halo.showWarning(msg);
    else alert(msg);
    return true;
  }

  window.HaloFulfillmentQty = {
    __ready: true,
    _userSelected: false,
    applyIntent,
    reapply(options) {
      const root = getRoot();
      if (!root) return;
      applyIntent(currentIntent(root), options || {});
    },
    clampQuantityInputs,
    findDeliveryMinViolations,
    warnDeliveryMin,
  };

  document.addEventListener('click', onFulfillmentClick, true);

  document.addEventListener('change', (e) => {
    const input = e.target;
    if (!input || input.name !== 'quantity') return;
    if (input.getAttribute('data-jh-qty-intent') !== PICKUP) return;
    clampQuantityInputs();
  }, true);

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('#cart-sidebar-checkout');
    if (!btn || btn.disabled) return;
    if (warnDeliveryMin(findDeliveryMinViolations())) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }
    const href = btn.getAttribute('data-href');
    if (href) {
      e.preventDefault();
      window.location = href;
    }
  }, true);

  function boot() {
    const root = getRoot();
    if (!root) {
      setTimeout(boot, 50);
      return;
    }
    applyIntent(currentIntent(root), { resetQty: true });
    [100, 400].forEach((ms) => {
      setTimeout(() => {
        if (window.HaloFulfillmentQty._userSelected) return;
        const r = getRoot();
        if (r) applyIntent(currentIntent(r), { resetQty: true });
      }, ms);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
